import React from 'react';
import './PopUpBenefitContent.scss';
import {popupReport} from './popupReport';

const PopUpWithBenefit = (props) => {

  const dwhContinueToUpdateContactDetails = {
    area : 'SelfCare',
    subArea : 'Personal Info Update',
    channel : 'WebsitePrivate',
    status : 'Ongoing',
    customerName : props.dwhDetails.customerName,
    subscriber : '',
    idNumber : props.dwhDetails.contactId,
    param1 : props.dwhDetails.param1,
    param3 : '',
    actionType : 'Display PopUp Benefit not available',
    messageText : 'Clicked Continue to Update Info',
    param2 : props.param2,
    param4 : "BENEFIT ISN'T AVAILABLE",
  };

  const dwhClosePopup={
    area : 'SelfCare',
    subArea : 'Personal Info Update',
    channel : 'WebsitePrivate',
    status : 'Ongoing',
    customerName : props.dwhDetails.customerName,
    subscriber : '',
    idNumber : props.dwhDetails.contactId,
    param1 : props.dwhDetails.param1,
    actionType : 'Clicked Close PopUp Without Update',
    messageText : 'Clicked Close PopUp Without Update',
    param2 : props.param2,
    param3 : '',
    param4 : "BENEFIT ISN'T AVAILABLE",
  };


    return (
        <>
          <div className='popUpBenefitContainer'>          
             {props.children}
             
            <button className='btn-submit' onClick={() => {popupReport(dwhContinueToUpdateContactDetails),props.onNavigate('submit')}}>
              <span className='benefitButtonText'> {props.benefitButtonText}</span>
            </button>
    
            <input type='button' onClick={() => {popupReport(dwhClosePopup),props.onClose('remind')}} className='btn-remind' value={props.benefitSecondButtonText} />
          </div>
        </>
      );
};
export default PopUpWithBenefit;
